import CanvasRenderer from './canvas_renderer';

export default class Distribution {
  constructor(canvas) {
    this.canvas = canvas;
    this.canvasRenderer = new CanvasRenderer(canvas);
  }

  distribute(direction) {
    this[`distribute${direction}`]();
  }

  distributeHorizontal() {
    const positions = this.canvas.getActiveObjects();
    if (positions.length <= 2) return;

    const left = this.getMin(positions, 'left');
    const right = this.getMax(positions, 'left');
    const totalWidth = right - left;
    const space = totalWidth / (positions.length - 1);

    const sortedPositions = positions.sort((a, b) => a.left - b.left);
    this.distributePositions(sortedPositions, 'left', space);
    this.canvasRenderer.refreshSelections(positions);
  }

  distributeVertical() {
    const positions = this.canvas.getActiveObjects();
    if (positions.length <= 2) return;

    const top = this.getMin(positions, 'top');
    const bottom = this.getMax(positions, 'top');
    const totalHeight = bottom - top;
    const space = totalHeight / (positions.length - 1);

    const sortedPositions = positions.sort((a, b) => a.top - b.top);
    this.distributePositions(sortedPositions, 'top', space);
    this.canvasRenderer.refreshSelections(positions);
  }

  distributePositions(positions, axis, value) {
    positions.forEach((position, index) => {
      if (index === 0 || index === positions.length - 1) return;

      const initialLeft = position.left;
      const initialTop = position.top;

      position[axis] = positions[0][axis] + (value * index);
      position.setCoords()

      const { left, top } = position;
      const leftOffset = left - initialLeft;
      const topOffset = top - initialTop;

      position.fire('selection:moved', { leftOffset, topOffset });
    });
  }

  getMin(positions, axis) {
    return Math.min(...positions.map(pos => pos[axis]));
  }

  getMax(positions, axis) {
    return Math.max(...positions.map(pos => pos[axis]));
  }
}
